import { useEnv } from '@/components/providers/env-provider';
import { useUser } from '@/components/providers/user-provider';
import { zodResolver } from '@hookform/resolvers/zod';
import { marketToLocales } from '@ingka-group-digital/pnv-shared';
import { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

export const NONE_VALUE = 'none';
export const ROLES = [
  { label: 'Admin', value: 'admin' },
  { label: 'Creator', value: 'creator' },
  { label: 'Editor', value: 'editor' },
] as const;

export const formSchema = z.object({
  email: z
    .string()
    .min(1, { message: 'This field has to be filled.' })
    .email('This is not a valid email.'),
  role: z.string(),
  marketRestrictions: z.array(z.string()),
});

function UserutilsHook() {
  const { env } = useEnv();
  const { role } = useUser();

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      email: '',
      role: '',
      marketRestrictions: [],
    },
  });

  const markets = useMemo(() => {
    const result = [{ label: 'None', value: NONE_VALUE }];
    for (const [key, value] of Object.entries(marketToLocales)) {
      const [, market] = value[0].split('-');
      result.push({
        label: key,
        value: market,
      });
    }

    return result;
  }, []);
  return { markets, form, env, role };
}

export { UserutilsHook };
